import React, { useEffect, useMemo, useState } from "react";
import { serverDomain } from "../../../config";
import "../../../styles/OfferRequestsPage.css";

const statusLabel = (s) => {
  if (s === "pending") return "Ожидает";
  if (s === "approved") return "Одобрено";
  if (s === "rejected") return "Отклонено";
  return s || "—";
};

const statusClass = (s) => {
  if (s === "pending") return "fl-status fl-status--pending";
  if (s === "approved") return "fl-status fl-status--approved";
  if (s === "rejected") return "fl-status fl-status--rejected";
  return "fl-status";
};

const OfferRequestsPage = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [q, setQ] = useState("");
  const [savingId, setSavingId] = useState(null);

  const fetchRequests = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      setErr("");
      const response = await fetch(`${serverDomain}/api/admin/offer-requests`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) throw new Error("Ошибка загрузки заявок");
      const data = await response.json();
      setRequests(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error("Ошибка загрузки заявок:", e);
      setErr(e.message || "Ошибка загрузки");
      setRequests([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return requests;

    return requests.filter((r) => {
      const hay = [
        r.user_email,
        r.traffic_source,
        r.expected_volume,
        r.status,
      ]
        .map((x) => (x == null ? "" : String(x).toLowerCase()))
        .join(" ");
      return hay.includes(s);
    });
  }, [requests, q]);

  const pendingCount = useMemo(
    () => filtered.filter((r) => r.status === "pending").length,
    [filtered]
  );

  const handleDecision = async (id, status) => {
    const token = localStorage.getItem("token");
    try {
      setSavingId(id);

      const res = await fetch(`${serverDomain}/api/admin/offer-requests/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ status }),
      });

      if (!res.ok) throw new Error("Ошибка при подтверждении/отклонении");

      setRequests((prev) =>
        prev.map((req) => (req.id === id ? { ...req, status } : req))
      );
    } catch (e) {
      console.error(e);
      alert(e.message || "Ошибка");
    } finally {
      setSavingId(null);
    }
  };

  return (
    <div className="fl-adminpage fl-offerreq">
      <div className="fl-adminpage__head">
        <h2 className="fl-h2">Заявки на приватный оффер №3</h2>
        <div className="fl-adminpage__meta">
          Всего: <b>{filtered.length}</b> · Ожидают: <b>{pendingCount}</b>
        </div>
      </div>

      <div className="fl-toolbar fl-offerreq__toolbar">
        <input
          className="fl-input fl-input--wide"
          placeholder="Поиск: email / источник / объём / статус…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
        <button
          className="fl-btn fl-btn--ghost"
          type="button"
          onClick={fetchRequests}
          disabled={loading}
        >
          {loading ? "Загрузка…" : "Обновить"}
        </button>
      </div>

      {err ? <div className="fl-alert fl-alert--error">{err}</div> : null}

      {loading ? (
        <div className="loading-container">
          <div className="loader" />
        </div>
      ) : filtered.length === 0 ? (
        <div className="fl-empty">Заявок нет</div>
      ) : (
        <div className="fl-table-wrap">
          <table className="fl-table fl-offerreq__table">
            <thead>
              <tr>
                <th>Пользователь</th>
                <th className="col-source">Источник трафика</th>
                <th className="col-volume">Объём</th>
                <th style={{ width: 140 }}>Статус</th>
                <th style={{ width: 220 }}>Действия</th>
              </tr>
            </thead>

            <tbody>
              {filtered.map((req) => (
                <tr key={req.id}>
                  <td className="fl-ellipsis" title={req.user_email}>
                    {req.user_email || "—"}
                  </td>
                  <td className="col-source fl-ellipsis" title={req.traffic_source || ""}>
                    {req.traffic_source || "—"}
                  </td>
                  <td className="col-volume fl-ellipsis" title={req.expected_volume || ""}>
                    {req.expected_volume || "—"}
                  </td>
                  <td>
                    <span className={statusClass(req.status)}>{statusLabel(req.status)}</span>
                  </td>
                  <td>
                    {req.status === "pending" ? (
                      <div className="fl-offerreq__actions">
                        <button
                          className="fl-btn fl-btn--mini"
                          type="button"
                          onClick={() => handleDecision(req.id, "approved")}
                          disabled={savingId === req.id}
                        >
                          {savingId === req.id ? "…" : "✅ Одобрить"}
                        </button>

                        <button
                          className="fl-btn fl-btn--mini fl-btn--danger"
                          type="button"
                          onClick={() => handleDecision(req.id, "rejected")}
                          disabled={savingId === req.id}
                        >
                          {savingId === req.id ? "…" : "❌ Отклонить"}
                        </button>
                      </div>
                    ) : (
                      <span className="fl-muted">—</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default OfferRequestsPage;